export function arrayRange(start: number, stop: number, step: number): number[] {
    return Array.from({length: (stop - start) / step + 1}, (_value, index) => start + index * step);
}

export function chunkArray<T>(array: T[], size: number): T[][] {
    return Array.from({length: Math.ceil(array.length / size)}, (_value, index) => array.slice(index * size, index * size + size));
}
